export const diagCodes = [
  {
    code: "709",
    description: "Skin abnormality, rash NYD",
    category: "skin",
  },
  {
    code: "782",
    description: "Skin symptoms",
    category: "skin",
  },

  {
    code: "919",
    description: "Abrasion, brise, bite, FB, crush",
    category: "skin",
  },
  {
    code: "682",
    description: "Abscess",
    category: "skin",
  },

  {
    code: "919",
    description: "Abscess - Pilonidal cysts",
    category: "skin",
  },
  {
    code: "949",
    description: "Burn",
    category: "skin",
  },
  {
    code: "910",
    description: "Bites - Insect",
    category: "skin",
  },
  {
    code: "112",
    description: "Candida",
    category: "skin",
  },

  {
    code: "682",
    description: "Cellulitis",
    category: "skin",
  },
  {
    code: "702",
    description: "Dermatitis",
    category: "skin",
  },
  {
    code: "684",
    description: "Impetigo",
    category: "skin",
  },
  {
    code: "910",
    description: "Insect Bites",
    category: "skin",
  },
  {
    code: "691",
    description: "Rash",
    category: "skin",
  },
  {
    code: "133",
    description: "Scabies",
    category: "skin",
  },
  {
    code: "706",
    description: "Sebaceous Cyst",
    category: "skin",
  },
  {
    code: "454",
    description: "Stasis Derm/ulcers, varicose",
    category: "skin",
  },
  {
    code: "708",
    description: "Uritcaria",
    category: "skin",
  },
  {
    code: "539",
    description: "Zoster",
    category: "skin",
  },
  {
    code: "078",
    description: "Warts",
    category: "skin",
  },

  /* --------------- Cardiac----------------- */

  {
    code: "412",
    description: "Angina",
    category: "cvs",
  },
  {
    code: "441",
    description: "Aortic Aneurysm",
    category: "cvs",
  },
  {
    code: "427",
    description: "Arrythmia",
    category: "cvs",
  },
  {
    code: "429",
    description:
      "Cardiomyopathy, endocarditis, vavle disease, other cardiac and pericardial disease",
    category: "cvs",
  },
  {
    code: "785",
    description: "Chest Pain",
    category: "cvs",
  },
  {
    code: "428",
    description: "CHF",
    category: "cvs",
  },
  {
    code: "451",
    description: "DVT, PE, thromboembolism",
    category: "cvs",
  },
  {
    code: "426",
    description: "Heart Block",
    category: "cvs",
  },
  {
    code: "401",
    description: "Hypertension",
    category: "cvs",
  },
  {
    code: "410",
    description: "MI - acute",
    category: "cvs",
  },
  {
    code: "785",
    description: "Palpitation",
    category: "cvs",
  },

  {
    code: "427",
    description: "SVT, arrythmia, afib, arrest",
    category: "cvs",
  },
  {
    code: "785",
    description: "Syncope",
    category: "cvs",
  },

  {
    code: "443",
    description: "Peripheral vascular disease",
    category: "cvs",
  },
  {
    code: "415",
    description: "Pulmonary Embolism",
    category: "cvs",
  },

  /* ------------- RESP --------------------*/

  {
    code: "493",
    description: "Asthma",
    category: "resp",
  },
  {
    code: "466",
    description: "Bronchitis",
    category: "resp",
  },

  {
    code: "492",
    description: "COPD",
    category: "resp",
  },
  {
    code: "464",
    description: "Croup",
    category: "resp",
  },
  {
    code: "451",
    description: "DVT, PE, thromboembolism",
    category: "resp",
  },
  {
    code: "464",
    description: "Laryngitis, Epiglotittis",
    category: "resp",
  },
  {
    code: "460",
    description: "Pharyngitis",
    category: "resp",
  },
  {
    code: "511",
    description: "Plerual effusion",
    category: "resp",
  },
  {
    code: "486",
    description: "Pneumonia",
    category: "resp",
  },
  {
    code: "512",
    description: "Pneumothorax",
    category: "resp",
  },
  {
    code: "461",
    description: "Sinusitis",
    category: "resp",
  },

  /* -- Infection  ---- */

  {
    code: "112",
    description: "Pneumonia",
    category: "id",
  },
  {
    code: "619",
    description: "Candida",
    category: "id",
  },
  {
    code: "682",
    description: "Cellulits",
    category: "id",
  },
  {
    code: "616",
    description: "Cervicitis",
    category: "id",
  },
  {
    code: "052",
    description: "Chicken Pox",
    category: "id",
  },
  {
    code: "080",
    description: "COVID",
    category: "id",
  },

  {
    code: "070",
    description: "Hepatitis",
    category: "id",
  },
  {
    code: "099",
    description: "Herpes",
    category: "id",
  },
  {
    code: "053",
    description: "Herpes Zoster",
    category: "id",
  },
  {
    code: "054",
    description: "Herpes Simplex",
    category: "id",
  },
  {
    code: "487",
    description: "Influenza",
    category: "id",
  },
  {
    code: "055",
    description: "Measles",
    category: "id",
  },
  {
    code: "075",
    description: "Mononucleosis, EBV",
    category: "id",
  },
  {
    code: "072",
    description: "Mumps",
    category: "id",
  },
  {
    code: "099",
    description: "STI",
    category: "id",
  },
  {
    code: "034",
    description: "Strepp pharyngitis",
    category: "id",
  },
  {
    code: "010",
    description: "TB",
    category: "id",
  },
  {
    code: "078",
    description: "Warts",
    category: "id",
  },

  /*-------------------  GI --------------->*/

  {
    code: "787",
    description: "Abod pain NYD",
    category: "gi",
  },
  {
    code: "560",
    description: "Hernia - abdominal",
    category: "gi",
  },
  {
    code: "565",
    description: "Anal fissure",
    category: "gi",
  },
  {
    code: "549",
    description: "Appendicitis",
    category: "gi",
  },
  {
    code: "574",
    description: "Cholecystitis",
    category: "gi",
  },
  {
    code: "565",
    description: "Constipation",
    category: "gi",
  },
  {
    code: "555",
    description: "Crohns",
    category: "gi",
  },
  {
    code: "009",
    description: "Diarrhea/Gastroenteritis",
    category: "gi",
  },
  {
    code: "562",
    description: "Diverticulosis",
    category: "gi",
  },
  {
    code: "532",
    description: "Duodenal ulcer",
    category: "gi",
  },
  {
    code: "530",
    description: "Esophagitis",
    category: "gi",
  },
  {
    code: "531",
    description: "Gastric ulcer",
    category: "gi",
  },
  {
    code: "535",
    description: "Gastritis",
    category: "gi",
  },
  {
    code: "536",
    description: "Heartburn, GERD, dyspepsia",
    category: "gi",
  },
  {
    code: "455",
    description: "Hemmorhoids",
    category: "gi",
  },
  {
    code: "553",
    description: "Hernia: abd, fem, diaph, hiatus",
    category: "gi",
  },

  {
    code: "369",
    description: "Blindness, loss of vision",
    category: "eye",
  },
  {
    code: "372",
    description: "Conjunctivitis, subconjunctival hemmorhage",
    category: "eye",
  },
  {
    code: "370",
    description: "Corneal Ulcer",
    category: "eye",
  },
  {
    code: "379",
    description: "Eye pain NYD",
    category: "eye",
  },
  {
    code: "930",
    description: "Foreign Body",
    category: "eye",
  },
  {
    code: "365",
    description: "Glaucoma",
    category: "eye",
  },
  {
    code: "378",
    description: "Diplopia",
    category: "eye",
  },
  {
    code: "373",
    description: "Stye, blepharitis, lid problem",
    category: "eye",
  },

  /*---------------- ENT -------------------*/

  {
    code: "351",
    description: "Bell's Palsy",
    category: "ent",
  },

  {
    code: "388",
    description: "Earwax",
    category: "ent",
  },
  {
    code: "786",
    description: "Epistaxis",
    category: "ent",
  },
  {
    code: "939",
    description: "Foreign body - ear",
    category: "ent",
  },
  {
    code: "379",
    description: "Hearing Loss",
    category: "ent",
  },
  {
    code: "386",
    description: "Labyrinthitis",
    category: "ent",
  },
  {
    code: "386",
    description: "Meniere's, BPVertigo",
    category: "ent",
  },
  {
    code: "380",
    description: "Otitis externa",
    category: "ent",
  },
  {
    code: "382",
    description: "Otitis Media",
    category: "ent",
  },
  {
    code: "461",
    description: "Sinusitis",
    category: "ent",
  },
  {
    code: "034",
    description: "Strepp throat",
    category: "ent",
  },
  {
    code: "521",
    description: "Dental problem: caries, asbcess",
    category: "teeth",
  },
  {
    code: "523",
    description: "Gingivitis",
    category: "teeth",
  },
  {
    code: "524",
    description: "Mandible/TMJ problem",
    category: "teeth",
  },
  {
    code: "527",
    description: "Salivary gland",
    category: "teeth",
  },
  {
    code: "528",
    description: "Stomatitis, apthous ulcer",
    category: "teeth",
  },

  {
    code: "525",
    description: "Dental pain, teething",
    category: "teeth",
  },
  {
    code: "781",
    description: "Abnormal involuntary movement",
    category: "neuro",
  },
  {
    code: "351",
    description: "Bell's Palsy",
    category: "neuro",
  },

  {
    code: "850",
    description: "Concussion",
    category: "neuro",
  },
  {
    code: "523",
    description: "Head injury/Acute Conccusion",
    category: "neuro",
  },

  {
    code: "780",
    description: "Headache NYD",
    category: "neuro",
  },
  {
    code: "346",
    description: "Headache - Migraine",
    category: "neuro",
  },
  {
    code: "307",
    description: "Headache - Tension",
    category: "neuro",
  },
  {
    code: "320",
    description: "Mennigitis",
    category: "neuro",
  },
  {
    code: "346",
    description: "Migraine",
    category: "neuro",
  },
  {
    code: "340",
    description: "Muliptle Sclerosis",
    category: "neuro",
  },
  {
    code: "780",
    description: "Paresthesia",
    category: "neuro",
  },
  {
    code: "332",
    description: "Parkinson's",
    category: "neuro",
  },
  {
    code: "739",
    description: "Peripheral nerve, CTS, BELL's",
    category: "neuro",
  },
  {
    code: "345",
    description: "Seizure Disorder",
    category: "neuro",
  },
  {
    code: "436",
    description: "Stroke (acute)",
    category: "neuro",
  },
  {
    code: "437",
    description: "Stroke (chronic)",
    category: "neuro",
  },

  {
    code: "435",
    description: "TIA",
    category: "neuro",
  },
  {
    code: "780",
    description: "Vertigo",
    category: "neuro",
  },

  /*-- GU ---------------------------*/

  {
    code: "607",
    description: "Balanitis",
    category: "gu",
  },
  {
    code: "600",
    description: "BPH",
    category: "gu",
  },

  
  {
    code: "604",
    description: "Epididymitis, orchitis",
    category: "gu",
  },

  {
    code: "599",
    description: "Hematuria, proteinuria, incontinence, renal problem",
    category: "gu",
  },
  {
    code: "603",
    description: "Hydrocele",
    category: "gu",
  },
  {
    code: "608",
    description: "Male genital problem",
    category: "gu",
  },

  {
    code: "605",
    description: "Phimosis",
    category: "gu",
  },

  {
    code: "601",
    description: "Prostatits",
    category: "gu",
  },
  {
    code: "590",
    description: "Pyelonephritis",
    category: "gu",
  },
  {
    code: "584",
    description: "Renal failure",
    category: "gu",
  },
  {
    code: "099",
    description: "STI",
    category: "gu",
  },
  {
    code: "592",
    description: "Stone - bladder, renal",
    category: "gu",
  },
  {
    code: "598",
    description: "Urethral stricture",
    category: "gu",
  },
  {
    code: "595",
    description: "UTI",
    category: "gu",
  },

  /*------------------------ GYne ----------------------*/

  {
    code: "650",
    description: "Delivery - normal",
    category: "gyne",
  },
  {
    code: "627",
    description: "Dysfunctional uterine bleeding",
    category: "gyne",
  },
  {
    code: "626",
    description: "Dysmennorhea",
    category: "gyne",
  },
  {
    code: "634",
    description: "Early fetal loss - Complete/Incomplete",
    category: "gyne",
  },
  {
    code: "632",
    description: "Early fetal loss - Missed",
    category: "gyne",
  },
  {
    code: "640",
    description: "Early fetal loss - Threatened",
    category: "gyne",
  },
  {
    code: "642",
    description: "Eclampsia, Pre-eclampsia, toxaemia",
    category: "gyne",
  },

  {
    code: "615",
    description: "Ectopic pregnancy",
    category: "gyne",
  },
  {
    code: "615",
    description: "Endometriosis",
    category: "gyne",
  },
  {
    code: "642",
    description: "Eclampsia, Pre-eclampsia, toxaemia",
    category: "gyne",
  },

  {
    code: "218",
    description: "Fibroid",
    category: "gyne",
  },
  {
    code: "643",
    description: "Hyperemesis",
    category: "gyne",
  },
  {
    code: "378",
    description: "IUD",
    category: "gyne",
  },
  {
    code: "626",
    description: "Menorrhagia",
    category: "gyne",
  },

  {
    code: "611",
    description: "Menopausal symtoms",
    category: "gyne",
  },

  {
    code: "256",
    description: "Ovarian cyst",
    category: "gyne",
  },
  {
    code: "614",
    description: "PID - Pelvic inflammatory diesease",
    category: "gyne",
  },
  {
    code: "669",
    description: "Post-partum complications",
    category: "gyne",
  },

  {
    code: "650",
    description: "Pregnancy - normal",
    category: "gyne",
  },
  {
    code: "099",
    description: "STI",
    category: "gyne",
  },
  {
    code: "616",
    description: "Vaginitis",
    category: "gyne",
  },

  /* ---------------Psych --------------------*/

  {
    code: "303",
    description: "Alchohol problems",
    category: "psych",
  },
  {
    code: "316",
    description: "Anorexia",
    category: "psych",
  },
  {
    code: "300",
    description: "Anxiety",
    category: "psych",
  },

  {
    code: "312",
    description: "Behaviour problem",
    category: "psych",
  },
  {
    code: "290",
    description: "Dementia",
    category: "psych",
  },
  {
    code: "300",
    description: "Depression",
    category: "psych",
  },
  {
    code: "304",
    description: "Drug abuse/addiction",
    category: "psych",
  },
  {
    code: "307",
    description: "Insomnia",
    category: "psych",
  },
  {
    code: "977",
    description: "Overdose",
    category: "psych",
  },

  {
    code: "301",
    description: "Personality Disorder",
    category: "psych",
  },
  {
    code: "298",
    description: "Psychosis",
    category: "psych",
  },
  {
    code: "295",
    description: "Schizophrenia",
    category: "psych",
  },
  /* ----------Endo/blood --------------------*/

  {
    code: "790",
    description: "Abnormal lab results",
    category: "blood",
  },
  {
    code: "285",
    description: "Anemia",
    category: "blood",
  },
  {
    code: "287",
    description: "Coag disorder, anticoag",
    category: "blood",
  },
  {
    code: "250",
    description: "Diabetes",
    category: "blood",
  },
  {
    code: "269",
    description: "Nutritional deficient/FTT",
    category: "blood",
  },
  {
    code: "274",
    description: "Gout",
    category: "blood",
  },
  {
    code: "242",
    description: "Hyperthyroid",
    category: "blood",
  },
  {
    code: "244",
    description: "Hypothyroid",
    category: "blood",
  },

  {
    code: "269",
    description: "Hypoglycemia",
    category: "blood",
  },
  {
    code: "274",
    description: "Gout",
    category: "blood",
  },
  {
    code: "274",
    description: "Neutropenia, WBC abnormality",
    category: "blood",
  },
  {
    code: "683",
    description: "Lymphadenopathy",
    category: "blood",
  },

  {
    code: "199",
    description: "Neoplasm - malignant",
    category: "blood",
  },
  {
    code: "279",
    description: "Thyroiditis",
    category: "blood",
  },

  /* -------------    msk ------------------- */

  {
    code: "739",
    description: "Arthritis",
    category: "nyd",
  },
  {
    code: "839",
    description: "Dislocation",
    category: "nyd",
  },

  {
    code: "829",
    description: "Fracture",
    category: "msk",
  },
  {
    code: "274",
    description: "Gout",
    category: "msk",
  },
  {
    code: "959",
    description: "Injury or trauma - other",
    category: "msk",
  },



  {
    code: "848",
    description: "Muscle Sprain/Strain",
    category: "msk",
  },

  {
    code: "715",
    description: "Osteoarthritis",
    category: "msk",
  },

  /*------------nyd--------------*/
  {
    code: "977",
    description:
      "Adverse Effects - Drugs and Medications - including allergy, overdose, reactions",
    category: "nyd",
  },
  {
    code: "787",
    description: "Abdominal Pain NYD",
    category: "nyd",
  },
  {
    code: "785",
    description: "Chest Pain NYD",
    category: "nyd",
  },
  {
    code: "780",
    description: "Dizziness",
    category: "nyd",
  },
  {
    code: "786",
    description: "Dyspnea/SOB",
    category: "nyd",
  },
  {
    code: "780",
    description: "Headache",
    category: "nyd",
  },

  {
    code: "959",
    description: "Injury or trauma - other",
    category: "nyd",
  },
  {
    code: "199",
    description: "Neoplasm - malignant",
    category: "nyd",
  },
  {
    code: "798",
    description: "Sudden death - unknown cause",
    category: "nyd",
  },
  {
    code: "785",
    description: "Syncope",
    category: "nyd",
  },

  {
    code: "691",
    description: "Rash",
    category: "nyd",
  },

  /* laceration */

  {
    code: "884",
    description: "Laceration - upper limb",
    category: "lac",
  },
  {
    code: "894",
    description: "Laceration - lower limb",
    category: "lac",
  },
  {
    code: "879",
    description: "Laceration - except limbs",
    category: "lac",
  },

  /* Breast */

  {
    code: "611",
    description: "Breast disorder",
    category: "breast",
  },
  {
    code: "785",
    description: "Breast mass",
    category: "breast",
  },
  {
    code: "174",
    description: "Breast ca",
    category: "breast",
  },
  {
    code: "610",
    description: "Breast abscess",
    category: "breast",
  },
  {
    code: "675",
    description: "Mastitis",
    category: "breast",
  },
 
  

];
